
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bWXzv", function(module, exports) {
module.exports = jQuery;

});

// import 'svgxuse'; // Uncomment to support svg icons on IE
// import add, { selectSomething } from './components/example';
// bower_components/aos/dist/aos.js
// import 'aos';
var $a8deec0f19dfb2f6$exports = {};
!function(e, t) {
    $a8deec0f19dfb2f6$exports = t();
}($a8deec0f19dfb2f6$exports, function() {
    "use strict";
    var e = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, t = "Expected a function", n = NaN, o = "[object Symbol]", i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, c = /^0o[0-7]+$/i, s = parseInt, u = "object" == typeof e && e && e.Object === Object && e, d = "object" == typeof self && self && self.Object === Object && self, l = u || d || Function("return this")(), f = Object.prototype.toString, m = Math.max, p = Math.min, b = function() {
        return l.Date.now();
    };
    function v(e, n, o) {
        var i, a, r, c, s, u, d = 0, l = !1, f = !1, v = !0;
        if ("function" != typeof e) throw new TypeError(t);
        function y(t) {
            var n = i, o = a;
            return i = a = void 0, d = t, c = e.apply(o, n);
        }
        function h(e) {
            var t = e - u;
            return void 0 === u || t >= n || t < 0 || f && e - d >= r;
        }
        function k() {
            var e = b();
            if (h(e)) return x(e);
            s = setTimeout(k, function(e) {
                var t = n - (e - u);
                return f ? p(t, r - (e - d)) : t;
            }(e));
        }
        function x(e) {
            return s = void 0, v && i ? y(e) : (i = a = void 0, c);
        }
        function O() {
            var e = b(), t = h(e);
            if (i = arguments, a = this, u = e, t) {
                if (void 0 === s) return function(e) {
                    return d = e, s = setTimeout(k, n), l ? y(e) : c;
                }(u);
                if (f) return s = setTimeout(k, n), y(u);
            }
            return void 0 === s && (s = setTimeout(k, n)), c;
        }
        return n = w(n) || 0, g(o) && (l = !!o.leading, r = (f = "maxWait" in o) ? m(w(o.maxWait) || 0, n) : r, v = "trailing" in o ? !!o.trailing : v), O.cancel = function() {
            void 0 !== s && clearTimeout(s), d = 0, i = u = a = s = void 0;
        }, O.flush = function() {
            return void 0 === s ? c : x(b());
        }, O;
    }
    function g(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function w(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && f.call(e) == o;
        }(e)) return n;
        if (g(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = g(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(i, "");
        var u = r.test(e);
        return u || c.test(e) ? s(e.slice(2), u ? 2 : 8) : a.test(e) ? n : +e;
    }
    var y = function(e, n, o) {
        var i = !0, a = !0;
        if ("function" != typeof e) throw new TypeError(t);
        return g(o) && (i = "leading" in o ? !!o.leading : i, a = "trailing" in o ? !!o.trailing : a), v(e, n, {
            leading: i,
            maxWait: n,
            trailing: a
        });
    }, h = "Expected a function", k = NaN, x = "[object Symbol]", O = /^\s+|\s+$/g, j = /^[-+]0x[0-9a-f]+$/i, E = /^0b[01]+$/i, N = /^0o[0-7]+$/i, z = parseInt, C = "object" == typeof e && e && e.Object === Object && e, A = "object" == typeof self && self && self.Object === Object && self, q = C || A || Function("return this")(), L = Object.prototype.toString, T = Math.max, M = Math.min, S = function() {
        return q.Date.now();
    };
    function D(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function H(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && L.call(e) == x;
        }(e)) return k;
        if (D(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = D(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(O, "");
        var n = E.test(e);
        return n || N.test(e) ? z(e.slice(2), n ? 2 : 8) : j.test(e) ? k : +e;
    }
    var $ = function(e, t, n) {
        var o, i, a, r, c, s, u = 0, d = !1, l = !1, f = !0;
        if ("function" != typeof e) throw new TypeError(h);
        function m(t) {
            var n = o, a = i;
            return o = i = void 0, u = t, r = e.apply(a, n);
        }
        function p(e) {
            var n = e - s;
            return void 0 === s || n >= t || n < 0 || l && e - u >= a;
        }
        function b() {
            var e = S();
            if (p(e)) return v(e);
            c = setTimeout(b, function(e) {
                var n = t - (e - s);
                return l ? M(n, a - (e - u)) : n;
            }(e));
        }
        function v(e) {
            return c = void 0, f && o ? m(e) : (o = i = void 0, r);
        }
        function g() {
            var e = S(), n = p(e);
            if (o = arguments, i = this, s = e, n) {
                if (void 0 === c) return function(e) {
                    return u = e, c = setTimeout(b, t), d ? m(e) : r;
                }(s);
                if (l) return c = setTimeout(b, t), m(s);
            }
            return void 0 === c && (c = setTimeout(b, t)), r;
        }
        return t = H(t) || 0, D(n) && (d = !!n.leading, a = (l = "maxWait" in n) ? T(H(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), g.cancel = function() {
            void 0 !== c && clearTimeout(c), u = 0, o = s = i = c = void 0;
        }, g.flush = function() {
            return void 0 === c ? r : v(S());
        }, g;
    }, W = function() {};
    function P(e) {
        e && e.forEach(function(e) {
            var t = Array.prototype.slice.call(e.addedNodes), n = Array.prototype.slice.call(e.removedNodes);
            if (function e(t) {
                var n = void 0, o = void 0;
                for(n = 0; n < t.length; n += 1){
                    if ((o = t[n]).dataset && o.dataset.aos) return !0;
                    if (o.children && e(o.children)) return !0;
                }
                return !1;
            }(t.concat(n))) return W();
        });
    }
    function Y() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    var _ = {
        isSupported: function() {
            return !!Y();
        },
        ready: function(e, t) {
            var n = window.document, o = new (Y())(P);
            W = t, o.observe(n.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0
            });
        }
    }, B = function(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, F = function() {
        function e(e, t) {
            for(var n = 0; n < t.length; n++){
                var o = t[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
        }
        return function(t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
        };
    }(), I = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
    }, K = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, G = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, J = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, Q = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
    function R() {
        return navigator.userAgent || navigator.vendor || window.opera || "";
    }
    var U = new (function() {
        function e() {
            B(this, e);
        }
        return F(e, [
            {
                key: "phone",
                value: function() {
                    var e = R();
                    return !(!K.test(e) && !G.test(e.substr(0, 4)));
                }
            },
            {
                key: "mobile",
                value: function() {
                    var e = R();
                    return !(!J.test(e) && !Q.test(e.substr(0, 4)));
                }
            },
            {
                key: "tablet",
                value: function() {
                    return this.mobile() && !this.phone();
                }
            },
            {
                key: "ie11",
                value: function() {
                    return "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                }
            }
        ]), e;
    }()), V = function(e, t) {
        var n = void 0;
        return U.ie11() ? (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, {
            detail: t
        }) : n = new CustomEvent(e, {
            detail: t
        }), document.dispatchEvent(n);
    }, X = function(e) {
        return e.forEach(function(e, t) {
            return function(e, t) {
                var n = e.options, o = e.position, i = e.node, a = (e.data, function() {
                    e.animated && (function(e, t) {
                        t && t.forEach(function(t) {
                            return e.classList.remove(t);
                        });
                    }(i, n.animatedClassNames), V("aos:out", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !1);
                });
                n.mirror && t >= o.out && !n.once ? a() : t >= o.in ? e.animated || (function(e, t) {
                    t && t.forEach(function(t) {
                        return e.classList.add(t);
                    });
                }(i, n.animatedClassNames), V("aos:in", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !0) : e.animated && !n.once && a();
            }(e, window.pageYOffset);
        });
    }, Z = function(e) {
        for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
        return {
            top: n,
            left: t
        };
    }, ee = function(e, t, n) {
        var o = e.getAttribute("data-aos-" + t);
        if (void 0 !== o) {
            if ("true" === o) return !0;
            if ("false" === o) return !1;
        }
        return o || n;
    }, te = function(e, t) {
        return e.forEach(function(e, n) {
            var o = ee(e.node, "mirror", t.mirror), i = ee(e.node, "once", t.once), a = ee(e.node, "id"), r = t.useClassNames && e.node.getAttribute("data-aos"), c = [
                t.animatedClassName
            ].concat(r ? r.split(" ") : []).filter(function(e) {
                return "string" == typeof e;
            });
            t.initClassName && e.node.classList.add(t.initClassName), e.position = {
                in: function(e, t, n) {
                    var o = window.innerHeight, i = ee(e, "anchor"), a = ee(e, "anchor-placement"), r = Number(ee(e, "offset", a ? 0 : t)), c = a || n, s = e;
                    i && document.querySelectorAll(i) && (s = document.querySelectorAll(i)[0]);
                    var u = Z(s).top - o;
                    switch(c){
                        case "top-bottom":
                            break;
                        case "center-bottom":
                            u += s.offsetHeight / 2;
                            break;
                        case "bottom-bottom":
                            u += s.offsetHeight;
                            break;
                        case "top-center":
                            u += o / 2;
                            break;
                        case "center-center":
                            u += o / 2 + s.offsetHeight / 2;
                            break;
                        case "bottom-center":
                            u += o / 2 + s.offsetHeight;
                            break;
                        case "top-top":
                            u += o;
                            break;
                        case "bottom-top":
                            u += o + s.offsetHeight;
                            break;
                        case "center-top":
                            u += o + s.offsetHeight / 2;
                    }
                    return u + r;
                }(e.node, t.offset, t.anchorPlacement),
                out: o && function(e, t) {
                    window.innerHeight;
                    var n = ee(e, "anchor"), o = ee(e, "offset", t), i = e;
                    return n && document.querySelectorAll(n) && (i = document.querySelectorAll(n)[0]), Z(i).top + i.offsetHeight - o;
                }(e.node, t.offset)
            }, e.options = {
                once: i,
                mirror: o,
                animatedClassNames: c,
                id: a
            };
        }), e;
    }, ne = function() {
        var e = document.querySelectorAll("[data-aos]");
        return Array.prototype.map.call(e, function(e) {
            return {
                node: e
            };
        });
    }, oe = [], ie = !1, ae = {
        offset: 120,
        delay: 0,
        easing: "ease",
        duration: 400,
        disable: !1,
        once: !1,
        mirror: !1,
        anchorPlacement: "top-bottom",
        startEvent: "DOMContentLoaded",
        animatedClassName: "aos-animate",
        initClassName: "aos-init",
        useClassNames: !1,
        disableMutationObserver: !1,
        throttleDelay: 99,
        debounceDelay: 50
    }, re = function() {
        return document.all && !window.atob;
    }, ce = function() {
        arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (ie = !0), ie && (oe = te(oe, ae), X(oe), window.addEventListener("scroll", y(function() {
            X(oe, ae.once);
        }, ae.throttleDelay)));
    }, se = function() {
        if (oe = ne(), de(ae.disable) || re()) return ue();
        ce();
    }, ue = function() {
        oe.forEach(function(e, t) {
            e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay"), ae.initClassName && e.node.classList.remove(ae.initClassName), ae.animatedClassName && e.node.classList.remove(ae.animatedClassName);
        });
    }, de = function(e) {
        return !0 === e || "mobile" === e && U.mobile() || "phone" === e && U.phone() || "tablet" === e && U.tablet() || "function" == typeof e && !0 === e();
    };
    return {
        init: function(e) {
            return ae = I(ae, e), oe = ne(), ae.disableMutationObserver || _.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), ae.disableMutationObserver = !0), ae.disableMutationObserver || _.ready("[data-aos]", se), de(ae.disable) || re() ? ue() : (document.querySelector("body").setAttribute("data-aos-easing", ae.easing), document.querySelector("body").setAttribute("data-aos-duration", ae.duration), document.querySelector("body").setAttribute("data-aos-delay", ae.delay), -1 === [
                "DOMContentLoaded",
                "load"
            ].indexOf(ae.startEvent) ? document.addEventListener(ae.startEvent, function() {
                ce(!0);
            }) : window.addEventListener("load", function() {
                ce(!0);
            }), "DOMContentLoaded" === ae.startEvent && [
                "complete",
                "interactive"
            ].indexOf(document.readyState) > -1 && ce(!0), window.addEventListener("resize", $(ce, ae.debounceDelay, !0)), window.addEventListener("orientationchange", $(ce, ae.debounceDelay, !0)), oe);
        },
        refresh: ce,
        refreshHard: se
    };
});



var $bWXzv = parcelRequire("bWXzv");
var $4d19433dac172d81$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ 
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([
        'jquery'
    ], factory);
    else $4d19433dac172d81$exports = factory((parcelRequire("bWXzv")));
})(function($) {
    'use strict';
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data('slick') || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = 'translate(0px,' + now + 'px)';
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
            else animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && typeof asNavFor === 'object') asNavFor.each(function() {
            var target = $(this).slick('getSlick');
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        else transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
            } else _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                'aria-disabled': 'true',
                'tabindex': '-1'
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');
            dot = $('<ul />').addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find('li').first().addClass('slick-active');
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });
        _.$slider.addClass('slick-slider');
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass('draggable');
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === 'window') respondToWidth = windowWidth;
        else if (_.respondTo === 'slider') respondToWidth = sliderWidth;
        else if (_.respondTo === 'min') respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger('breakpoint', [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is('a')) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) $target = $target.closest('li');
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off('keydown.slick', _.keyHandler);
        }
        _.$slider.off('focus.slick blur.slick');
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }
        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
        _.$list.off('click.slick', _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $('.slick-cloned', _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                $(this).attr('style', $(this).data('originalStyling'));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');
        _.unslicked = true;
        if (!refresh) _.$slider.trigger('destroy', [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = '';
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger('init', [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) $(this).attr({
                        'aria-describedby': ariaButtonControl
                    });
                }
            });
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    'role': 'presentation'
                });
                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            'tabindex': '0'
        });
        else _.$slides.eq(i).removeAttr('tabindex');
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on('keydown.slick', _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('click.slick', _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr('data-lazy'), imageSrcSet = $(this).attr('data-srcset'), imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'), imageToLoad = document.createElement('img');
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) image.attr('sizes', imageSizes);
                        }
                        image.attr('src', imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find('.slick-slide');
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass('slick-loading');
        _.initUI();
        if (_.options.lazyLoad === 'progressive') _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger('afterChange', [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $('img[data-lazy]', _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);
                    if (imageSizes) image.attr('sizes', imageSizes);
                }
                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger('lazyLoaded', [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger('allImagesLoaded', [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: 'index',
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger('reInit', [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: '0px ' + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + ' 0px'
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') type = 'responsive';
            else if (typeof arguments[1] !== 'undefined') type = 'single';
        }
        if (type === 'single') _.options[option] = value;
        else if (type === 'multiple') $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === 'responsive') {
            for(item in value)if ($.type(_.options.responsive) !== 'array') _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger('setPosition', [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? 'top' : 'left';
        if (_.positionProp === 'top') _.$slider.addClass('slick-vertical');
        else _.$slider.removeClass('slick-vertical');
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
        _.$slides.eq(index).addClass('slick-current');
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass('slick-center');
            }
            _.$slides.eq(index).addClass('slick-center');
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            }
        }
        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
        var index = parseInt(targetElement.attr('data-slick-index'));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger('beforeChange', [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass('slick-loading');
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? 'right' : 'left';
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return 'down';
            else return 'up';
        }
        return 'vertical';
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger('edge', [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case 'left':
                case 'down':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case 'right':
                case 'up':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != 'vertical') {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case 'start':
                _.swipeStart(event);
                break;
            case 'move':
                _.swipeMove(event);
                break;
            case 'end':
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $('.slick-cloned', _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger('unslick', [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();
            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});


console.log('faqs-slider.js');
(0, (/*@__PURE__*/$parcel$interopDefault($bWXzv)))(".js-faqs-slider").each(function() {
    const $block = (0, (/*@__PURE__*/$parcel$interopDefault($bWXzv)))(this);
    const $track = $block.find(".js-faqs-slider__track");
    //   const $prev = $block.find(".js-slider-arrow-prev");
    //   const $next = $block.find(".js-slider-arrow-next");
    const $dots = $block.find(".js-faqs-slider__dots");
    $track.slick({
        infinite: true,
        centerMode: true,
        autoplay: false,
        // slidesToShow: 3,
        // slidesToScroll: 1,
        variableWidth: true,
        dots: true,
        dotsClass: "",
        appendDots: $dots,
        draggable: true,
        adaptiveHeight: false,
        arrows: false,
        // nextArrow: $next,
        // prevArrow: $prev,
        fade: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true
                }
            }
        ]
    });
});



var $bWXzv = parcelRequire("bWXzv");
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $1305c0a6451a6c72$exports = {};

$parcel$export($1305c0a6451a6c72$exports, "popperGenerator", function () { return $0e452eaeef801f41$export$ed5e13716264f202; });
$parcel$export($1305c0a6451a6c72$exports, "detectOverflow", function () { return $c200c59b1c59e334$export$2e2bcd8739ae039; });
$parcel$export($1305c0a6451a6c72$exports, "createPopperBase", function () { return $0e452eaeef801f41$export$8f7491d57c8f97a9; });
$parcel$export($1305c0a6451a6c72$exports, "createPopper", function () { return $505a09c3f17aad18$export$8f7491d57c8f97a9; });
$parcel$export($1305c0a6451a6c72$exports, "createPopperLite", function () { return $2ec6ef3de1be3904$export$8f7491d57c8f97a9; });
var $97f6279b6bda8f09$exports = {};

$parcel$export($97f6279b6bda8f09$exports, "top", function () { return $97f6279b6bda8f09$export$1e95b668f3b82d; });
$parcel$export($97f6279b6bda8f09$exports, "bottom", function () { return $97f6279b6bda8f09$export$40e543e69a8b3fbb; });
$parcel$export($97f6279b6bda8f09$exports, "right", function () { return $97f6279b6bda8f09$export$79ffe56a765070d2; });
$parcel$export($97f6279b6bda8f09$exports, "left", function () { return $97f6279b6bda8f09$export$eabcd2c8791e7bf4; });
$parcel$export($97f6279b6bda8f09$exports, "auto", function () { return $97f6279b6bda8f09$export$dfb5619354ba860; });
$parcel$export($97f6279b6bda8f09$exports, "basePlacements", function () { return $97f6279b6bda8f09$export$aec2ce47c367b8c3; });
$parcel$export($97f6279b6bda8f09$exports, "start", function () { return $97f6279b6bda8f09$export$b3571188c770cc5a; });
$parcel$export($97f6279b6bda8f09$exports, "end", function () { return $97f6279b6bda8f09$export$bd5df0f255a350f8; });
$parcel$export($97f6279b6bda8f09$exports, "clippingParents", function () { return $97f6279b6bda8f09$export$390fd549c5303b4d; });
$parcel$export($97f6279b6bda8f09$exports, "viewport", function () { return $97f6279b6bda8f09$export$d7b7311ec04a3e8f; });
$parcel$export($97f6279b6bda8f09$exports, "popper", function () { return $97f6279b6bda8f09$export$ae5ab1c730825774; });
$parcel$export($97f6279b6bda8f09$exports, "reference", function () { return $97f6279b6bda8f09$export$ca50aac9f3ba507f; });
$parcel$export($97f6279b6bda8f09$exports, "variationPlacements", function () { return $97f6279b6bda8f09$export$368f9a87e87fa4e1; });
$parcel$export($97f6279b6bda8f09$exports, "placements", function () { return $97f6279b6bda8f09$export$803cd8101b6c182b; });
$parcel$export($97f6279b6bda8f09$exports, "beforeRead", function () { return $97f6279b6bda8f09$export$421679a7c3d56e; });
$parcel$export($97f6279b6bda8f09$exports, "read", function () { return $97f6279b6bda8f09$export$aafa59e2e03f2942; });
$parcel$export($97f6279b6bda8f09$exports, "afterRead", function () { return $97f6279b6bda8f09$export$6964f6c886723980; });
$parcel$export($97f6279b6bda8f09$exports, "beforeMain", function () { return $97f6279b6bda8f09$export$c65e99957a05207c; });
$parcel$export($97f6279b6bda8f09$exports, "main", function () { return $97f6279b6bda8f09$export$f22da7240b7add18; });
$parcel$export($97f6279b6bda8f09$exports, "afterMain", function () { return $97f6279b6bda8f09$export$bab79516f2d662fe; });
$parcel$export($97f6279b6bda8f09$exports, "beforeWrite", function () { return $97f6279b6bda8f09$export$8d4d2d70e7d46032; });
$parcel$export($97f6279b6bda8f09$exports, "write", function () { return $97f6279b6bda8f09$export$68d8715fc104d294; });
$parcel$export($97f6279b6bda8f09$exports, "afterWrite", function () { return $97f6279b6bda8f09$export$70a6e5159acce2e6; });
$parcel$export($97f6279b6bda8f09$exports, "modifierPhases", function () { return $97f6279b6bda8f09$export$d087d3878fdf71d5; });
var $97f6279b6bda8f09$export$1e95b668f3b82d = 'top';
var $97f6279b6bda8f09$export$40e543e69a8b3fbb = 'bottom';
var $97f6279b6bda8f09$export$79ffe56a765070d2 = 'right';
var $97f6279b6bda8f09$export$eabcd2c8791e7bf4 = 'left';
var $97f6279b6bda8f09$export$dfb5619354ba860 = 'auto';
var $97f6279b6bda8f09$export$aec2ce47c367b8c3 = [
    $97f6279b6bda8f09$export$1e95b668f3b82d,
    $97f6279b6bda8f09$export$40e543e69a8b3fbb,
    $97f6279b6bda8f09$export$79ffe56a765070d2,
    $97f6279b6bda8f09$export$eabcd2c8791e7bf4
];
var $97f6279b6bda8f09$export$b3571188c770cc5a = 'start';
var $97f6279b6bda8f09$export$bd5df0f255a350f8 = 'end';
var $97f6279b6bda8f09$export$390fd549c5303b4d = 'clippingParents';
var $97f6279b6bda8f09$export$d7b7311ec04a3e8f = 'viewport';
var $97f6279b6bda8f09$export$ae5ab1c730825774 = 'popper';
var $97f6279b6bda8f09$export$ca50aac9f3ba507f = 'reference';
var $97f6279b6bda8f09$export$368f9a87e87fa4e1 = /*#__PURE__*/ $97f6279b6bda8f09$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $97f6279b6bda8f09$export$b3571188c770cc5a,
        placement + "-" + $97f6279b6bda8f09$export$bd5df0f255a350f8
    ]);
}, []);
var $97f6279b6bda8f09$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($97f6279b6bda8f09$export$aec2ce47c367b8c3, [
    $97f6279b6bda8f09$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $97f6279b6bda8f09$export$b3571188c770cc5a,
        placement + "-" + $97f6279b6bda8f09$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $97f6279b6bda8f09$export$421679a7c3d56e = 'beforeRead';
var $97f6279b6bda8f09$export$aafa59e2e03f2942 = 'read';
var $97f6279b6bda8f09$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $97f6279b6bda8f09$export$c65e99957a05207c = 'beforeMain';
var $97f6279b6bda8f09$export$f22da7240b7add18 = 'main';
var $97f6279b6bda8f09$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $97f6279b6bda8f09$export$8d4d2d70e7d46032 = 'beforeWrite';
var $97f6279b6bda8f09$export$68d8715fc104d294 = 'write';
var $97f6279b6bda8f09$export$70a6e5159acce2e6 = 'afterWrite';
var $97f6279b6bda8f09$export$d087d3878fdf71d5 = [
    $97f6279b6bda8f09$export$421679a7c3d56e,
    $97f6279b6bda8f09$export$aafa59e2e03f2942,
    $97f6279b6bda8f09$export$6964f6c886723980,
    $97f6279b6bda8f09$export$c65e99957a05207c,
    $97f6279b6bda8f09$export$f22da7240b7add18,
    $97f6279b6bda8f09$export$bab79516f2d662fe,
    $97f6279b6bda8f09$export$8d4d2d70e7d46032,
    $97f6279b6bda8f09$export$68d8715fc104d294,
    $97f6279b6bda8f09$export$70a6e5159acce2e6
];


var $9977f8712d2f3064$exports = {};

$parcel$export($9977f8712d2f3064$exports, "applyStyles", function () { return $aa2b8542698a7f7f$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "arrow", function () { return $7e51efda9e6180a8$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "computeStyles", function () { return $4c6d919568662c13$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "eventListeners", function () { return $afda48b4f33d0664$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "flip", function () { return $8347741fa45ac751$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "hide", function () { return $ddeda4e2671100b0$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "offset", function () { return $c5a16ef44d34e30a$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "popperOffsets", function () { return $417cc193dc0883b1$export$2e2bcd8739ae039; });
$parcel$export($9977f8712d2f3064$exports, "preventOverflow", function () { return $690b99350124879d$export$2e2bcd8739ae039; });
function $0f763a778cdfb4f7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $5062ab1154804816$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $3be67126bd9b4dac$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $5062ab1154804816$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $3be67126bd9b4dac$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $5062ab1154804816$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $3be67126bd9b4dac$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $5062ab1154804816$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $aa2b8542698a7f7f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(element) || !(0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $aa2b8542698a7f7f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(element) || !(0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $aa2b8542698a7f7f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $aa2b8542698a7f7f$var$applyStyles,
    effect: $aa2b8542698a7f7f$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $7631b9671a26e6a6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $9f0aaf9815ede3ec$export$8960430cfd85939f = Math.max;
var $9f0aaf9815ede3ec$export$96ec731ed4dcb222 = Math.min;
var $9f0aaf9815ede3ec$export$2077e0241d6afd3c = Math.round;



function $da57ffef1a6cfc98$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $83fa64234a2d533a$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $da57ffef1a6cfc98$export$2e2bcd8739ae039)());
}


function $5a7e7382b73c29b9$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9f0aaf9815ede3ec$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9f0aaf9815ede3ec$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(element) ? (0, $5062ab1154804816$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $83fa64234a2d533a$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $d3947904e79cb06b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5a7e7382b73c29b9$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $c99e17cd1650e2ac$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $3be67126bd9b4dac$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $1f98442955c0287f$export$2e2bcd8739ae039(element) {
    return (0, $5062ab1154804816$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $e609df1e643ee305$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(element)) >= 0;
}




function $58e25a4811883d5e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $71f1663d3b2ae7fc$export$2e2bcd8739ae039(element) {
    if ((0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $3be67126bd9b4dac$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $58e25a4811883d5e$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $b16dc7f6a8cdadb3$var$getTrueOffsetParent(element) {
    if (!(0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1f98442955c0287f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b16dc7f6a8cdadb3$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $da57ffef1a6cfc98$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $da57ffef1a6cfc98$export$2e2bcd8739ae039)());
    if (isIE && (0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1f98442955c0287f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $71f1663d3b2ae7fc$export$2e2bcd8739ae039)(element);
    if ((0, $3be67126bd9b4dac$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $1f98442955c0287f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b16dc7f6a8cdadb3$export$2e2bcd8739ae039(element) {
    var window = (0, $5062ab1154804816$export$2e2bcd8739ae039)(element);
    var offsetParent = $b16dc7f6a8cdadb3$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $e609df1e643ee305$export$2e2bcd8739ae039)(offsetParent) && (0, $1f98442955c0287f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $b16dc7f6a8cdadb3$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $1f98442955c0287f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $b16dc7f6a8cdadb3$var$getContainingBlock(element) || window;
}


function $8a4bbd2407e0bd00$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9270feb2329bc5b0$export$f28d906d67a997f3(min, value, max) {
    return (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(min, (0, $9f0aaf9815ede3ec$export$96ec731ed4dcb222)(value, max));
}
function $9270feb2329bc5b0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9270feb2329bc5b0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $cd37fbb3bc42b26b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $6f6a5cc1e66b5e82$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $cd37fbb3bc42b26b$export$2e2bcd8739ae039)(), paddingObject);
}


function $37dbbcbe71d27e14$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $7e51efda9e6180a8$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $6f6a5cc1e66b5e82$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $37dbbcbe71d27e14$export$2e2bcd8739ae039)(padding, (0, $97f6279b6bda8f09$export$aec2ce47c367b8c3)));
};
function $7e51efda9e6180a8$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8a4bbd2407e0bd00$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4),
        (0, $97f6279b6bda8f09$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7e51efda9e6180a8$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $d3947904e79cb06b$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $97f6279b6bda8f09$export$1e95b668f3b82d) : (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb) : (0, $97f6279b6bda8f09$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $b16dc7f6a8cdadb3$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $9270feb2329bc5b0$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7e51efda9e6180a8$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $c99e17cd1650e2ac$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7e51efda9e6180a8$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $7e51efda9e6180a8$var$arrow,
    effect: $7e51efda9e6180a8$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $1d781bfd78c28180$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $4c6d919568662c13$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $4c6d919568662c13$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9f0aaf9815ede3ec$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9f0aaf9815ede3ec$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $4c6d919568662c13$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4);
    var sideY = (0, $97f6279b6bda8f09$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $b16dc7f6a8cdadb3$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $5062ab1154804816$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $58e25a4811883d5e$export$2e2bcd8739ae039)(popper);
            if ((0, $1f98442955c0287f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $97f6279b6bda8f09$export$1e95b668f3b82d) || (placement === (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4) || placement === (0, $97f6279b6bda8f09$export$79ffe56a765070d2)) && variation === (0, $97f6279b6bda8f09$export$bd5df0f255a350f8)) {
            sideY = (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4) || (placement === (0, $97f6279b6bda8f09$export$1e95b668f3b82d) || placement === (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb)) && variation === (0, $97f6279b6bda8f09$export$bd5df0f255a350f8)) {
            sideX = (0, $97f6279b6bda8f09$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $4c6d919568662c13$var$unsetSides);
    var _ref4 = roundOffsets === true ? $4c6d919568662c13$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $5062ab1154804816$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $4c6d919568662c13$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $1d781bfd78c28180$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $4c6d919568662c13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $4c6d919568662c13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4c6d919568662c13$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $4c6d919568662c13$var$computeStyles,
    data: {}
};



var $afda48b4f33d0664$var$passive = {
    passive: true
};
function $afda48b4f33d0664$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $5062ab1154804816$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $afda48b4f33d0664$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $afda48b4f33d0664$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $afda48b4f33d0664$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $afda48b4f33d0664$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $afda48b4f33d0664$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $afda48b4f33d0664$var$effect,
    data: {}
};


var $99997e3aabfce6f4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $99997e3aabfce6f4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $99997e3aabfce6f4$var$hash[matched];
    });
}



var $b874e944140421a8$var$hash = {
    start: 'end',
    end: 'start'
};
function $b874e944140421a8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b874e944140421a8$var$hash[matched];
    });
}








function $0091bb8083db7897$export$2e2bcd8739ae039(node) {
    var win = (0, $5062ab1154804816$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $40325dba5ebcfc53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5a7e7382b73c29b9$export$2e2bcd8739ae039)((0, $58e25a4811883d5e$export$2e2bcd8739ae039)(element)).left + (0, $0091bb8083db7897$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $77da3a9ff5c0c00a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $5062ab1154804816$export$2e2bcd8739ae039)(element);
    var html = (0, $58e25a4811883d5e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $83fa64234a2d533a$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $40325dba5ebcfc53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $50d0b65a65510f94$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $58e25a4811883d5e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0091bb8083db7897$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $40325dba5ebcfc53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1f98442955c0287f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $253b1d530d9fc7c9$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1f98442955c0287f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $0039d1aed561a14a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(node) && (0, $253b1d530d9fc7c9$export$2e2bcd8739ae039)(node)) return node;
    return $0039d1aed561a14a$export$2e2bcd8739ae039((0, $71f1663d3b2ae7fc$export$2e2bcd8739ae039)(node));
}





function $4eb94df7a2b1652b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $0039d1aed561a14a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $5062ab1154804816$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $253b1d530d9fc7c9$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($4eb94df7a2b1652b$export$2e2bcd8739ae039((0, $71f1663d3b2ae7fc$export$2e2bcd8739ae039)(target)));
}










function $f72d2aca653c44b2$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $9f46eaa0437a5d7f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5a7e7382b73c29b9$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $97f6279b6bda8f09$export$d7b7311ec04a3e8f) ? (0, $f72d2aca653c44b2$export$2e2bcd8739ae039)((0, $77da3a9ff5c0c00a$export$2e2bcd8739ae039)(element, strategy)) : (0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(clippingParent) ? $9f46eaa0437a5d7f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $f72d2aca653c44b2$export$2e2bcd8739ae039)((0, $50d0b65a65510f94$export$2e2bcd8739ae039)((0, $58e25a4811883d5e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9f46eaa0437a5d7f$var$getClippingParents(element) {
    var clippingParents = (0, $4eb94df7a2b1652b$export$2e2bcd8739ae039)((0, $71f1663d3b2ae7fc$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1f98442955c0287f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(element) ? (0, $b16dc7f6a8cdadb3$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(clippingParent) && (0, $c99e17cd1650e2ac$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9f46eaa0437a5d7f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9f46eaa0437a5d7f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9f0aaf9815ede3ec$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9f0aaf9815ede3ec$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bfb63bbfa459ee48$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $1d781bfd78c28180$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $97f6279b6bda8f09$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $97f6279b6bda8f09$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $97f6279b6bda8f09$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8a4bbd2407e0bd00$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $97f6279b6bda8f09$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $97f6279b6bda8f09$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c200c59b1c59e334$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $97f6279b6bda8f09$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $97f6279b6bda8f09$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $97f6279b6bda8f09$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $6f6a5cc1e66b5e82$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $37dbbcbe71d27e14$export$2e2bcd8739ae039)(padding, (0, $97f6279b6bda8f09$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $97f6279b6bda8f09$export$ae5ab1c730825774) ? (0, $97f6279b6bda8f09$export$ca50aac9f3ba507f) : (0, $97f6279b6bda8f09$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9f46eaa0437a5d7f$export$2e2bcd8739ae039)((0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $58e25a4811883d5e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5a7e7382b73c29b9$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $bfb63bbfa459ee48$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $f72d2aca653c44b2$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $97f6279b6bda8f09$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $97f6279b6bda8f09$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $97f6279b6bda8f09$export$79ffe56a765070d2),
                (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $97f6279b6bda8f09$export$1e95b668f3b82d),
                (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $b3eb9ea1beb1c95a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $97f6279b6bda8f09$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $1d781bfd78c28180$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $97f6279b6bda8f09$export$368f9a87e87fa4e1) : (0, $97f6279b6bda8f09$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $1d781bfd78c28180$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $97f6279b6bda8f09$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c200c59b1c59e334$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $8347741fa45ac751$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(placement) === (0, $97f6279b6bda8f09$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $99997e3aabfce6f4$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b874e944140421a8$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b874e944140421a8$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $8347741fa45ac751$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $99997e3aabfce6f4$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $8347741fa45ac751$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(placement) === (0, $97f6279b6bda8f09$export$dfb5619354ba860) ? (0, $b3eb9ea1beb1c95a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $1d781bfd78c28180$export$2e2bcd8739ae039)(placement) === (0, $97f6279b6bda8f09$export$b3571188c770cc5a);
        var isVertical = [
            (0, $97f6279b6bda8f09$export$1e95b668f3b82d),
            (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c200c59b1c59e334$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $97f6279b6bda8f09$export$79ffe56a765070d2) : (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb) : (0, $97f6279b6bda8f09$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $99997e3aabfce6f4$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $99997e3aabfce6f4$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $8347741fa45ac751$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $8347741fa45ac751$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $ddeda4e2671100b0$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $ddeda4e2671100b0$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $97f6279b6bda8f09$export$1e95b668f3b82d),
        (0, $97f6279b6bda8f09$export$79ffe56a765070d2),
        (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb),
        (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $ddeda4e2671100b0$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c200c59b1c59e334$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c200c59b1c59e334$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $ddeda4e2671100b0$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $ddeda4e2671100b0$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $ddeda4e2671100b0$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $ddeda4e2671100b0$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $ddeda4e2671100b0$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $ddeda4e2671100b0$var$hide
};




function $c5a16ef44d34e30a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4),
        (0, $97f6279b6bda8f09$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4),
        (0, $97f6279b6bda8f09$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c5a16ef44d34e30a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $97f6279b6bda8f09$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $c5a16ef44d34e30a$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c5a16ef44d34e30a$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c5a16ef44d34e30a$var$offset
};



function $417cc193dc0883b1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $bfb63bbfa459ee48$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $417cc193dc0883b1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $417cc193dc0883b1$var$popperOffsets,
    data: {}
};





function $0e6fcf6842904e1b$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $690b99350124879d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c200c59b1c59e334$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7631b9671a26e6a6$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $1d781bfd78c28180$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8a4bbd2407e0bd00$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $0e6fcf6842904e1b$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $97f6279b6bda8f09$export$1e95b668f3b82d) : (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb) : (0, $97f6279b6bda8f09$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $97f6279b6bda8f09$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $97f6279b6bda8f09$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $d3947904e79cb06b$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $cd37fbb3bc42b26b$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $9270feb2329bc5b0$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $b16dc7f6a8cdadb3$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $9270feb2329bc5b0$export$f28d906d67a997f3)(tether ? (0, $9f0aaf9815ede3ec$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9f0aaf9815ede3ec$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $97f6279b6bda8f09$export$1e95b668f3b82d) : (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $97f6279b6bda8f09$export$40e543e69a8b3fbb) : (0, $97f6279b6bda8f09$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $97f6279b6bda8f09$export$1e95b668f3b82d),
            (0, $97f6279b6bda8f09$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $9270feb2329bc5b0$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $9270feb2329bc5b0$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $690b99350124879d$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $690b99350124879d$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $1f682dc8f3467c95$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $f2665ffdcfb247eb$export$2e2bcd8739ae039(node) {
    if (node === (0, $5062ab1154804816$export$2e2bcd8739ae039)(node) || !(0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(node)) return (0, $0091bb8083db7897$export$2e2bcd8739ae039)(node);
    else return (0, $1f682dc8f3467c95$export$2e2bcd8739ae039)(node);
}








function $2be1064b9c8a4d4e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9f0aaf9815ede3ec$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9f0aaf9815ede3ec$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $2be1064b9c8a4d4e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(offsetParent) && $2be1064b9c8a4d4e$var$isElementScaled(offsetParent);
    var documentElement = (0, $58e25a4811883d5e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $5a7e7382b73c29b9$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $0f763a778cdfb4f7$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $253b1d530d9fc7c9$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $f2665ffdcfb247eb$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $3be67126bd9b4dac$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $5a7e7382b73c29b9$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $40325dba5ebcfc53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $020c15f23ea3ef06$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $020c15f23ea3ef06$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $020c15f23ea3ef06$var$order(modifiers); // order based on phase
    return (0, $97f6279b6bda8f09$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $07f5ace1f6980bf8$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f2720922427b522a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $0e452eaeef801f41$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $0e452eaeef801f41$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $0e452eaeef801f41$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0e452eaeef801f41$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $0e452eaeef801f41$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $3be67126bd9b4dac$export$45a5e7f76e0caa8d)(reference) ? (0, $4eb94df7a2b1652b$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $4eb94df7a2b1652b$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $4eb94df7a2b1652b$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $020c15f23ea3ef06$export$2e2bcd8739ae039)((0, $f2720922427b522a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0e452eaeef801f41$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2be1064b9c8a4d4e$export$2e2bcd8739ae039)(reference, (0, $b16dc7f6a8cdadb3$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $d3947904e79cb06b$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $07f5ace1f6980bf8$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0e452eaeef801f41$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0e452eaeef801f41$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0e452eaeef801f41$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $505a09c3f17aad18$export$d34966752335dd47 = [
    (0, $afda48b4f33d0664$export$2e2bcd8739ae039),
    (0, $417cc193dc0883b1$export$2e2bcd8739ae039),
    (0, $4c6d919568662c13$export$2e2bcd8739ae039),
    (0, $aa2b8542698a7f7f$export$2e2bcd8739ae039),
    (0, $c5a16ef44d34e30a$export$2e2bcd8739ae039),
    (0, $8347741fa45ac751$export$2e2bcd8739ae039),
    (0, $690b99350124879d$export$2e2bcd8739ae039),
    (0, $7e51efda9e6180a8$export$2e2bcd8739ae039),
    (0, $ddeda4e2671100b0$export$2e2bcd8739ae039)
];
var $505a09c3f17aad18$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $0e452eaeef801f41$export$ed5e13716264f202)({
    defaultModifiers: $505a09c3f17aad18$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $2ec6ef3de1be3904$export$d34966752335dd47 = [
    (0, $afda48b4f33d0664$export$2e2bcd8739ae039),
    (0, $417cc193dc0883b1$export$2e2bcd8739ae039),
    (0, $4c6d919568662c13$export$2e2bcd8739ae039),
    (0, $aa2b8542698a7f7f$export$2e2bcd8739ae039)
];
var $2ec6ef3de1be3904$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $0e452eaeef801f41$export$ed5e13716264f202)({
    defaultModifiers: $2ec6ef3de1be3904$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($1305c0a6451a6c72$exports, $97f6279b6bda8f09$exports);
$parcel$exportWildcard($1305c0a6451a6c72$exports, $9977f8712d2f3064$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$elementMap = new Map();
const $d0c6a6535cb335b9$var$Data = {
    set (element, key, instance) {
        if (!$d0c6a6535cb335b9$var$elementMap.has(element)) $d0c6a6535cb335b9$var$elementMap.set(element, new Map());
        const instanceMap = $d0c6a6535cb335b9$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($d0c6a6535cb335b9$var$elementMap.has(element)) return $d0c6a6535cb335b9$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$d0c6a6535cb335b9$var$elementMap.has(element)) return;
        const instanceMap = $d0c6a6535cb335b9$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $d0c6a6535cb335b9$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $d0c6a6535cb335b9$var$MAX_UID = 1000000;
const $d0c6a6535cb335b9$var$MILLISECONDS_MULTIPLIER = 1000;
const $d0c6a6535cb335b9$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $d0c6a6535cb335b9$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $d0c6a6535cb335b9$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $d0c6a6535cb335b9$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $d0c6a6535cb335b9$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $d0c6a6535cb335b9$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $d0c6a6535cb335b9$var$MILLISECONDS_MULTIPLIER;
};
const $d0c6a6535cb335b9$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($d0c6a6535cb335b9$var$TRANSITION_END));
};
const $d0c6a6535cb335b9$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $d0c6a6535cb335b9$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($d0c6a6535cb335b9$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($d0c6a6535cb335b9$var$parseSelector(object));
    return null;
};
const $d0c6a6535cb335b9$var$isVisible = (element)=>{
    if (!$d0c6a6535cb335b9$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $d0c6a6535cb335b9$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $d0c6a6535cb335b9$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $d0c6a6535cb335b9$var$findShadowRoot(element.parentNode);
};
const $d0c6a6535cb335b9$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $d0c6a6535cb335b9$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $d0c6a6535cb335b9$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $d0c6a6535cb335b9$var$DOMContentLoadedCallbacks = [];
const $d0c6a6535cb335b9$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$d0c6a6535cb335b9$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $d0c6a6535cb335b9$var$DOMContentLoadedCallbacks)callback();
        });
        $d0c6a6535cb335b9$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $d0c6a6535cb335b9$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $d0c6a6535cb335b9$var$defineJQueryPlugin = (plugin)=>{
    $d0c6a6535cb335b9$var$onDOMContentLoaded(()=>{
        const $ = $d0c6a6535cb335b9$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $d0c6a6535cb335b9$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback(...args) : defaultValue;
};
const $d0c6a6535cb335b9$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $d0c6a6535cb335b9$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $d0c6a6535cb335b9$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($d0c6a6535cb335b9$var$TRANSITION_END, handler);
        $d0c6a6535cb335b9$var$execute(callback);
    };
    transitionElement.addEventListener($d0c6a6535cb335b9$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $d0c6a6535cb335b9$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $d0c6a6535cb335b9$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $d0c6a6535cb335b9$var$stripNameRegex = /\..*/;
const $d0c6a6535cb335b9$var$stripUidRegex = /::\d+$/;
const $d0c6a6535cb335b9$var$eventRegistry = {}; // Events storage
let $d0c6a6535cb335b9$var$uidEvent = 1;
const $d0c6a6535cb335b9$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $d0c6a6535cb335b9$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $d0c6a6535cb335b9$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$d0c6a6535cb335b9$var$uidEvent++}` || element.uidEvent || $d0c6a6535cb335b9$var$uidEvent++;
}
function $d0c6a6535cb335b9$var$getElementEvents(element) {
    const uid = $d0c6a6535cb335b9$var$makeEventUid(element);
    element.uidEvent = uid;
    $d0c6a6535cb335b9$var$eventRegistry[uid] = $d0c6a6535cb335b9$var$eventRegistry[uid] || {};
    return $d0c6a6535cb335b9$var$eventRegistry[uid];
}
function $d0c6a6535cb335b9$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $d0c6a6535cb335b9$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $d0c6a6535cb335b9$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $d0c6a6535cb335b9$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $d0c6a6535cb335b9$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $d0c6a6535cb335b9$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $d0c6a6535cb335b9$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $d0c6a6535cb335b9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $d0c6a6535cb335b9$var$getTypeEvent(originalTypeEvent);
    if (!$d0c6a6535cb335b9$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $d0c6a6535cb335b9$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $d0c6a6535cb335b9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $d0c6a6535cb335b9$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $d0c6a6535cb335b9$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $d0c6a6535cb335b9$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $d0c6a6535cb335b9$var$makeEventUid(callable, originalTypeEvent.replace($d0c6a6535cb335b9$var$namespaceRegex, ''));
    const fn = isDelegated ? $d0c6a6535cb335b9$var$bootstrapDelegationHandler(element, handler, callable) : $d0c6a6535cb335b9$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $d0c6a6535cb335b9$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $d0c6a6535cb335b9$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $d0c6a6535cb335b9$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $d0c6a6535cb335b9$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $d0c6a6535cb335b9$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($d0c6a6535cb335b9$var$stripNameRegex, '');
    return $d0c6a6535cb335b9$var$customEvents[event] || event;
}
const $d0c6a6535cb335b9$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $d0c6a6535cb335b9$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $d0c6a6535cb335b9$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $d0c6a6535cb335b9$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $d0c6a6535cb335b9$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $d0c6a6535cb335b9$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$d0c6a6535cb335b9$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($d0c6a6535cb335b9$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $d0c6a6535cb335b9$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $d0c6a6535cb335b9$var$getjQuery();
        const typeEvent = $d0c6a6535cb335b9$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $d0c6a6535cb335b9$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $d0c6a6535cb335b9$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $d0c6a6535cb335b9$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $d0c6a6535cb335b9$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $d0c6a6535cb335b9$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$d0c6a6535cb335b9$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$d0c6a6535cb335b9$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $d0c6a6535cb335b9$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $d0c6a6535cb335b9$var$normalizeData(element.getAttribute(`data-bs-${$d0c6a6535cb335b9$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $d0c6a6535cb335b9$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $d0c6a6535cb335b9$var$isElement(element) ? $d0c6a6535cb335b9$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$d0c6a6535cb335b9$var$isElement(element) ? $d0c6a6535cb335b9$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $d0c6a6535cb335b9$var$isElement(value) ? 'element' : $d0c6a6535cb335b9$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$VERSION = '5.3.3';
/**
 * Class definition
 */ class $d0c6a6535cb335b9$var$BaseComponent extends $d0c6a6535cb335b9$var$Config {
    constructor(element, config){
        super();
        element = $d0c6a6535cb335b9$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $d0c6a6535cb335b9$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $d0c6a6535cb335b9$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $d0c6a6535cb335b9$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $d0c6a6535cb335b9$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $d0c6a6535cb335b9$var$Data.get($d0c6a6535cb335b9$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $d0c6a6535cb335b9$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $d0c6a6535cb335b9$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$d0c6a6535cb335b9$var$parseSelector(sel)).join(',') : null;
};
const $d0c6a6535cb335b9$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$d0c6a6535cb335b9$var$isDisabled(el) && $d0c6a6535cb335b9$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $d0c6a6535cb335b9$var$getSelector(element);
        if (selector) return $d0c6a6535cb335b9$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $d0c6a6535cb335b9$var$getSelector(element);
        return selector ? $d0c6a6535cb335b9$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $d0c6a6535cb335b9$var$getSelector(element);
        return selector ? $d0c6a6535cb335b9$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $d0c6a6535cb335b9$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $d0c6a6535cb335b9$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($d0c6a6535cb335b9$var$isDisabled(this)) return;
        const target = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$f = 'alert';
const $d0c6a6535cb335b9$var$DATA_KEY$a = 'bs.alert';
const $d0c6a6535cb335b9$var$EVENT_KEY$b = `.${$d0c6a6535cb335b9$var$DATA_KEY$a}`;
const $d0c6a6535cb335b9$var$EVENT_CLOSE = `close${$d0c6a6535cb335b9$var$EVENT_KEY$b}`;
const $d0c6a6535cb335b9$var$EVENT_CLOSED = `closed${$d0c6a6535cb335b9$var$EVENT_KEY$b}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_FADE$5 = 'fade';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$caec2af78bcc877f extends $d0c6a6535cb335b9$var$BaseComponent {
    // Getters
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$enableDismissTrigger($d0c6a6535cb335b9$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$e = 'button';
const $d0c6a6535cb335b9$var$DATA_KEY$9 = 'bs.button';
const $d0c6a6535cb335b9$var$EVENT_KEY$a = `.${$d0c6a6535cb335b9$var$DATA_KEY$9}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY$6 = '.data-api';
const $d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$3 = 'active';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$6 = `click${$d0c6a6535cb335b9$var$EVENT_KEY$a}${$d0c6a6535cb335b9$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$353f5b6fc5456de1 extends $d0c6a6535cb335b9$var$BaseComponent {
    // Getters
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$6, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$5);
    const data = $d0c6a6535cb335b9$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$d = 'swipe';
const $d0c6a6535cb335b9$var$EVENT_KEY$9 = '.bs.swipe';
const $d0c6a6535cb335b9$var$EVENT_TOUCHSTART = `touchstart${$d0c6a6535cb335b9$var$EVENT_KEY$9}`;
const $d0c6a6535cb335b9$var$EVENT_TOUCHMOVE = `touchmove${$d0c6a6535cb335b9$var$EVENT_KEY$9}`;
const $d0c6a6535cb335b9$var$EVENT_TOUCHEND = `touchend${$d0c6a6535cb335b9$var$EVENT_KEY$9}`;
const $d0c6a6535cb335b9$var$EVENT_POINTERDOWN = `pointerdown${$d0c6a6535cb335b9$var$EVENT_KEY$9}`;
const $d0c6a6535cb335b9$var$EVENT_POINTERUP = `pointerup${$d0c6a6535cb335b9$var$EVENT_KEY$9}`;
const $d0c6a6535cb335b9$var$POINTER_TYPE_TOUCH = 'touch';
const $d0c6a6535cb335b9$var$POINTER_TYPE_PEN = 'pen';
const $d0c6a6535cb335b9$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $d0c6a6535cb335b9$var$SWIPE_THRESHOLD = 40;
const $d0c6a6535cb335b9$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $d0c6a6535cb335b9$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$var$Swipe extends $d0c6a6535cb335b9$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$d0c6a6535cb335b9$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$c;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$c;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$d;
    }
    // Public
    dispose() {
        $d0c6a6535cb335b9$var$EventHandler.off(this._element, $d0c6a6535cb335b9$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $d0c6a6535cb335b9$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $d0c6a6535cb335b9$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $d0c6a6535cb335b9$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $d0c6a6535cb335b9$var$POINTER_TYPE_PEN || event.pointerType === $d0c6a6535cb335b9$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$c = 'carousel';
const $d0c6a6535cb335b9$var$DATA_KEY$8 = 'bs.carousel';
const $d0c6a6535cb335b9$var$EVENT_KEY$8 = `.${$d0c6a6535cb335b9$var$DATA_KEY$8}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY$5 = '.data-api';
const $d0c6a6535cb335b9$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $d0c6a6535cb335b9$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $d0c6a6535cb335b9$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $d0c6a6535cb335b9$var$ORDER_NEXT = 'next';
const $d0c6a6535cb335b9$var$ORDER_PREV = 'prev';
const $d0c6a6535cb335b9$var$DIRECTION_LEFT = 'left';
const $d0c6a6535cb335b9$var$DIRECTION_RIGHT = 'right';
const $d0c6a6535cb335b9$var$EVENT_SLIDE = `slide${$d0c6a6535cb335b9$var$EVENT_KEY$8}`;
const $d0c6a6535cb335b9$var$EVENT_SLID = `slid${$d0c6a6535cb335b9$var$EVENT_KEY$8}`;
const $d0c6a6535cb335b9$var$EVENT_KEYDOWN$1 = `keydown${$d0c6a6535cb335b9$var$EVENT_KEY$8}`;
const $d0c6a6535cb335b9$var$EVENT_MOUSEENTER$1 = `mouseenter${$d0c6a6535cb335b9$var$EVENT_KEY$8}`;
const $d0c6a6535cb335b9$var$EVENT_MOUSELEAVE$1 = `mouseleave${$d0c6a6535cb335b9$var$EVENT_KEY$8}`;
const $d0c6a6535cb335b9$var$EVENT_DRAG_START = `dragstart${$d0c6a6535cb335b9$var$EVENT_KEY$8}`;
const $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API$3 = `load${$d0c6a6535cb335b9$var$EVENT_KEY$8}${$d0c6a6535cb335b9$var$DATA_API_KEY$5}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$5 = `click${$d0c6a6535cb335b9$var$EVENT_KEY$8}${$d0c6a6535cb335b9$var$DATA_API_KEY$5}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_CAROUSEL = 'carousel';
const $d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$2 = 'active';
const $d0c6a6535cb335b9$var$CLASS_NAME_SLIDE = 'slide';
const $d0c6a6535cb335b9$var$CLASS_NAME_END = 'carousel-item-end';
const $d0c6a6535cb335b9$var$CLASS_NAME_START = 'carousel-item-start';
const $d0c6a6535cb335b9$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $d0c6a6535cb335b9$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $d0c6a6535cb335b9$var$SELECTOR_ACTIVE = '.active';
const $d0c6a6535cb335b9$var$SELECTOR_ITEM = '.carousel-item';
const $d0c6a6535cb335b9$var$SELECTOR_ACTIVE_ITEM = $d0c6a6535cb335b9$var$SELECTOR_ACTIVE + $d0c6a6535cb335b9$var$SELECTOR_ITEM;
const $d0c6a6535cb335b9$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $d0c6a6535cb335b9$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $d0c6a6535cb335b9$var$KEY_TO_DIRECTION = {
    [$d0c6a6535cb335b9$var$ARROW_LEFT_KEY$1]: $d0c6a6535cb335b9$var$DIRECTION_RIGHT,
    [$d0c6a6535cb335b9$var$ARROW_RIGHT_KEY$1]: $d0c6a6535cb335b9$var$DIRECTION_LEFT
};
const $d0c6a6535cb335b9$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $d0c6a6535cb335b9$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$144901db2ea8e967 extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $d0c6a6535cb335b9$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$b;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$b;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$c;
    }
    // Public
    next() {
        this._slide($d0c6a6535cb335b9$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $d0c6a6535cb335b9$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($d0c6a6535cb335b9$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $d0c6a6535cb335b9$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $d0c6a6535cb335b9$var$EventHandler.one(this._element, $d0c6a6535cb335b9$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $d0c6a6535cb335b9$var$EventHandler.one(this._element, $d0c6a6535cb335b9$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $d0c6a6535cb335b9$var$ORDER_NEXT : $d0c6a6535cb335b9$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $d0c6a6535cb335b9$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_ITEM_IMG, this._element))$d0c6a6535cb335b9$var$EventHandler.on(img, $d0c6a6535cb335b9$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $d0c6a6535cb335b9$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($d0c6a6535cb335b9$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($d0c6a6535cb335b9$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $d0c6a6535cb335b9$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $d0c6a6535cb335b9$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $d0c6a6535cb335b9$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $d0c6a6535cb335b9$var$ORDER_NEXT;
        const nextElement = element || $d0c6a6535cb335b9$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($d0c6a6535cb335b9$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $d0c6a6535cb335b9$var$CLASS_NAME_START : $d0c6a6535cb335b9$var$CLASS_NAME_END;
        const orderClassName = isNext ? $d0c6a6535cb335b9$var$CLASS_NAME_NEXT : $d0c6a6535cb335b9$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $d0c6a6535cb335b9$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($d0c6a6535cb335b9$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($d0c6a6535cb335b9$var$isRTL()) return direction === $d0c6a6535cb335b9$var$DIRECTION_LEFT ? $d0c6a6535cb335b9$var$ORDER_PREV : $d0c6a6535cb335b9$var$ORDER_NEXT;
        return direction === $d0c6a6535cb335b9$var$DIRECTION_LEFT ? $d0c6a6535cb335b9$var$ORDER_NEXT : $d0c6a6535cb335b9$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($d0c6a6535cb335b9$var$isRTL()) return order === $d0c6a6535cb335b9$var$ORDER_PREV ? $d0c6a6535cb335b9$var$DIRECTION_LEFT : $d0c6a6535cb335b9$var$DIRECTION_RIGHT;
        return order === $d0c6a6535cb335b9$var$ORDER_PREV ? $d0c6a6535cb335b9$var$DIRECTION_RIGHT : $d0c6a6535cb335b9$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$5, $d0c6a6535cb335b9$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $d0c6a6535cb335b9$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($d0c6a6535cb335b9$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$d0c6a6535cb335b9$var$EventHandler.on(window, $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$d0c6a6535cb335b9$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$b = 'collapse';
const $d0c6a6535cb335b9$var$DATA_KEY$7 = 'bs.collapse';
const $d0c6a6535cb335b9$var$EVENT_KEY$7 = `.${$d0c6a6535cb335b9$var$DATA_KEY$7}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY$4 = '.data-api';
const $d0c6a6535cb335b9$var$EVENT_SHOW$6 = `show${$d0c6a6535cb335b9$var$EVENT_KEY$7}`;
const $d0c6a6535cb335b9$var$EVENT_SHOWN$6 = `shown${$d0c6a6535cb335b9$var$EVENT_KEY$7}`;
const $d0c6a6535cb335b9$var$EVENT_HIDE$6 = `hide${$d0c6a6535cb335b9$var$EVENT_KEY$7}`;
const $d0c6a6535cb335b9$var$EVENT_HIDDEN$6 = `hidden${$d0c6a6535cb335b9$var$EVENT_KEY$7}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$4 = `click${$d0c6a6535cb335b9$var$EVENT_KEY$7}${$d0c6a6535cb335b9$var$DATA_API_KEY$4}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$7 = 'show';
const $d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE = 'collapse';
const $d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $d0c6a6535cb335b9$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE} .${$d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $d0c6a6535cb335b9$var$WIDTH = 'width';
const $d0c6a6535cb335b9$var$HEIGHT = 'height';
const $d0c6a6535cb335b9$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $d0c6a6535cb335b9$var$Default$a = {
    parent: null,
    toggle: true
};
const $d0c6a6535cb335b9$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$78768a9af065a7b extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $d0c6a6535cb335b9$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $d0c6a6535cb335b9$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$a;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$a;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($d0c6a6535cb335b9$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$d0c6a6535cb335b9$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE, $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $d0c6a6535cb335b9$var$reflow(this._element);
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE, $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSE);
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $d0c6a6535cb335b9$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_HORIZONTAL) ? $d0c6a6535cb335b9$var$WIDTH : $d0c6a6535cb335b9$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $d0c6a6535cb335b9$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($d0c6a6535cb335b9$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$4, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $d0c6a6535cb335b9$var$SelectorEngine.getMultipleElementsFromSelector(this))$d0c6a6535cb335b9$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$a = 'dropdown';
const $d0c6a6535cb335b9$var$DATA_KEY$6 = 'bs.dropdown';
const $d0c6a6535cb335b9$var$EVENT_KEY$6 = `.${$d0c6a6535cb335b9$var$DATA_KEY$6}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY$3 = '.data-api';
const $d0c6a6535cb335b9$var$ESCAPE_KEY$2 = 'Escape';
const $d0c6a6535cb335b9$var$TAB_KEY$1 = 'Tab';
const $d0c6a6535cb335b9$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $d0c6a6535cb335b9$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $d0c6a6535cb335b9$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $d0c6a6535cb335b9$var$EVENT_HIDE$5 = `hide${$d0c6a6535cb335b9$var$EVENT_KEY$6}`;
const $d0c6a6535cb335b9$var$EVENT_HIDDEN$5 = `hidden${$d0c6a6535cb335b9$var$EVENT_KEY$6}`;
const $d0c6a6535cb335b9$var$EVENT_SHOW$5 = `show${$d0c6a6535cb335b9$var$EVENT_KEY$6}`;
const $d0c6a6535cb335b9$var$EVENT_SHOWN$5 = `shown${$d0c6a6535cb335b9$var$EVENT_KEY$6}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$3 = `click${$d0c6a6535cb335b9$var$EVENT_KEY$6}${$d0c6a6535cb335b9$var$DATA_API_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DATA_API = `keydown${$d0c6a6535cb335b9$var$EVENT_KEY$6}${$d0c6a6535cb335b9$var$DATA_API_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_KEYUP_DATA_API = `keyup${$d0c6a6535cb335b9$var$EVENT_KEY$6}${$d0c6a6535cb335b9$var$DATA_API_KEY$3}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6 = 'show';
const $d0c6a6535cb335b9$var$CLASS_NAME_DROPUP = 'dropup';
const $d0c6a6535cb335b9$var$CLASS_NAME_DROPEND = 'dropend';
const $d0c6a6535cb335b9$var$CLASS_NAME_DROPSTART = 'dropstart';
const $d0c6a6535cb335b9$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $d0c6a6535cb335b9$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3}.${$d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6}`;
const $d0c6a6535cb335b9$var$SELECTOR_MENU = '.dropdown-menu';
const $d0c6a6535cb335b9$var$SELECTOR_NAVBAR = '.navbar';
const $d0c6a6535cb335b9$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $d0c6a6535cb335b9$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $d0c6a6535cb335b9$var$PLACEMENT_TOP = $d0c6a6535cb335b9$var$isRTL() ? 'top-end' : 'top-start';
const $d0c6a6535cb335b9$var$PLACEMENT_TOPEND = $d0c6a6535cb335b9$var$isRTL() ? 'top-start' : 'top-end';
const $d0c6a6535cb335b9$var$PLACEMENT_BOTTOM = $d0c6a6535cb335b9$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $d0c6a6535cb335b9$var$PLACEMENT_BOTTOMEND = $d0c6a6535cb335b9$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $d0c6a6535cb335b9$var$PLACEMENT_RIGHT = $d0c6a6535cb335b9$var$isRTL() ? 'left-start' : 'right-start';
const $d0c6a6535cb335b9$var$PLACEMENT_LEFT = $d0c6a6535cb335b9$var$isRTL() ? 'right-start' : 'left-start';
const $d0c6a6535cb335b9$var$PLACEMENT_TOPCENTER = 'top';
const $d0c6a6535cb335b9$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $d0c6a6535cb335b9$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $d0c6a6535cb335b9$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$931cbfb6bfb85fc extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $d0c6a6535cb335b9$var$SelectorEngine.next(this._element, $d0c6a6535cb335b9$var$SELECTOR_MENU)[0] || $d0c6a6535cb335b9$var$SelectorEngine.prev(this._element, $d0c6a6535cb335b9$var$SELECTOR_MENU)[0] || $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$9;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$9;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($d0c6a6535cb335b9$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($d0c6a6535cb335b9$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$d0c6a6535cb335b9$var$EventHandler.on(element, 'mouseover', $d0c6a6535cb335b9$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6);
        $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($d0c6a6535cb335b9$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$d0c6a6535cb335b9$var$EventHandler.off(element, 'mouseover', $d0c6a6535cb335b9$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $d0c6a6535cb335b9$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$d0c6a6535cb335b9$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$d0c6a6535cb335b9$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $1305c0a6451a6c72$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($d0c6a6535cb335b9$var$isElement(this._config.reference)) referenceElement = $d0c6a6535cb335b9$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $1305c0a6451a6c72$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_DROPEND)) return $d0c6a6535cb335b9$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_DROPSTART)) return $d0c6a6535cb335b9$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_DROPUP_CENTER)) return $d0c6a6535cb335b9$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_DROPDOWN_CENTER)) return $d0c6a6535cb335b9$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_DROPUP)) return isEnd ? $d0c6a6535cb335b9$var$PLACEMENT_TOPEND : $d0c6a6535cb335b9$var$PLACEMENT_TOP;
        return isEnd ? $d0c6a6535cb335b9$var$PLACEMENT_BOTTOMEND : $d0c6a6535cb335b9$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($d0c6a6535cb335b9$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $d0c6a6535cb335b9$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$d0c6a6535cb335b9$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$d0c6a6535cb335b9$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $d0c6a6535cb335b9$var$getNextActiveElement(items, target, key === $d0c6a6535cb335b9$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $d0c6a6535cb335b9$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $d0c6a6535cb335b9$var$TAB_KEY$1) return;
        const openToggles = $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $d0c6a6535cb335b9$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $d0c6a6535cb335b9$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $d0c6a6535cb335b9$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $d0c6a6535cb335b9$var$ARROW_UP_KEY$1,
            $d0c6a6535cb335b9$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3) ? this : $d0c6a6535cb335b9$var$SelectorEngine.prev(this, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3)[0] || $d0c6a6535cb335b9$var$SelectorEngine.next(this, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3)[0] || $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $d0c6a6535cb335b9$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DATA_API, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3, $d0c6a6535cb335b9$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DATA_API, $d0c6a6535cb335b9$var$SELECTOR_MENU, $d0c6a6535cb335b9$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$3, $d0c6a6535cb335b9$export$931cbfb6bfb85fc.clearMenus);
$d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_KEYUP_DATA_API, $d0c6a6535cb335b9$export$931cbfb6bfb85fc.clearMenus);
$d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$3, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $d0c6a6535cb335b9$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$9 = 'backdrop';
const $d0c6a6535cb335b9$var$CLASS_NAME_FADE$4 = 'fade';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$5 = 'show';
const $d0c6a6535cb335b9$var$EVENT_MOUSEDOWN = `mousedown.bs.${$d0c6a6535cb335b9$var$NAME$9}`;
const $d0c6a6535cb335b9$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $d0c6a6535cb335b9$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$var$Backdrop extends $d0c6a6535cb335b9$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$8;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$8;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $d0c6a6535cb335b9$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $d0c6a6535cb335b9$var$reflow(element);
        element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $d0c6a6535cb335b9$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $d0c6a6535cb335b9$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $d0c6a6535cb335b9$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $d0c6a6535cb335b9$var$EventHandler.off(this._element, $d0c6a6535cb335b9$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $d0c6a6535cb335b9$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $d0c6a6535cb335b9$var$EventHandler.on(element, $d0c6a6535cb335b9$var$EVENT_MOUSEDOWN, ()=>{
            $d0c6a6535cb335b9$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $d0c6a6535cb335b9$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$8 = 'focustrap';
const $d0c6a6535cb335b9$var$DATA_KEY$5 = 'bs.focustrap';
const $d0c6a6535cb335b9$var$EVENT_KEY$5 = `.${$d0c6a6535cb335b9$var$DATA_KEY$5}`;
const $d0c6a6535cb335b9$var$EVENT_FOCUSIN$2 = `focusin${$d0c6a6535cb335b9$var$EVENT_KEY$5}`;
const $d0c6a6535cb335b9$var$EVENT_KEYDOWN_TAB = `keydown.tab${$d0c6a6535cb335b9$var$EVENT_KEY$5}`;
const $d0c6a6535cb335b9$var$TAB_KEY = 'Tab';
const $d0c6a6535cb335b9$var$TAB_NAV_FORWARD = 'forward';
const $d0c6a6535cb335b9$var$TAB_NAV_BACKWARD = 'backward';
const $d0c6a6535cb335b9$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $d0c6a6535cb335b9$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$var$FocusTrap extends $d0c6a6535cb335b9$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$7;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$7;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $d0c6a6535cb335b9$var$EventHandler.off(document, $d0c6a6535cb335b9$var$EVENT_KEY$5); // guard against infinite focus loop
        $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $d0c6a6535cb335b9$var$EventHandler.off(document, $d0c6a6535cb335b9$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $d0c6a6535cb335b9$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $d0c6a6535cb335b9$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $d0c6a6535cb335b9$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $d0c6a6535cb335b9$var$TAB_NAV_BACKWARD : $d0c6a6535cb335b9$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $d0c6a6535cb335b9$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $d0c6a6535cb335b9$var$PROPERTY_PADDING = 'padding-right';
const $d0c6a6535cb335b9$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $d0c6a6535cb335b9$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $d0c6a6535cb335b9$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($d0c6a6535cb335b9$var$SELECTOR_FIXED_CONTENT, $d0c6a6535cb335b9$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($d0c6a6535cb335b9$var$SELECTOR_STICKY_CONTENT, $d0c6a6535cb335b9$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $d0c6a6535cb335b9$var$PROPERTY_PADDING);
        this._resetElementAttributes($d0c6a6535cb335b9$var$SELECTOR_FIXED_CONTENT, $d0c6a6535cb335b9$var$PROPERTY_PADDING);
        this._resetElementAttributes($d0c6a6535cb335b9$var$SELECTOR_STICKY_CONTENT, $d0c6a6535cb335b9$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $d0c6a6535cb335b9$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $d0c6a6535cb335b9$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $d0c6a6535cb335b9$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($d0c6a6535cb335b9$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $d0c6a6535cb335b9$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$7 = 'modal';
const $d0c6a6535cb335b9$var$DATA_KEY$4 = 'bs.modal';
const $d0c6a6535cb335b9$var$EVENT_KEY$4 = `.${$d0c6a6535cb335b9$var$DATA_KEY$4}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY$2 = '.data-api';
const $d0c6a6535cb335b9$var$ESCAPE_KEY$1 = 'Escape';
const $d0c6a6535cb335b9$var$EVENT_HIDE$4 = `hide${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_HIDDEN$4 = `hidden${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_SHOW$4 = `show${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_SHOWN$4 = `shown${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_RESIZE$1 = `resize${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DISMISS = `click.dismiss${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$d0c6a6535cb335b9$var$EVENT_KEY$4}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$2 = `click${$d0c6a6535cb335b9$var$EVENT_KEY$4}${$d0c6a6535cb335b9$var$DATA_API_KEY$2}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_OPEN = 'modal-open';
const $d0c6a6535cb335b9$var$CLASS_NAME_FADE$3 = 'fade';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$4 = 'show';
const $d0c6a6535cb335b9$var$CLASS_NAME_STATIC = 'modal-static';
const $d0c6a6535cb335b9$var$OPEN_SELECTOR$1 = '.modal.show';
const $d0c6a6535cb335b9$var$SELECTOR_DIALOG = '.modal-dialog';
const $d0c6a6535cb335b9$var$SELECTOR_MODAL_BODY = '.modal-body';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $d0c6a6535cb335b9$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $d0c6a6535cb335b9$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$2b77a92f1a5ad772 extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $d0c6a6535cb335b9$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$6;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$6;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $d0c6a6535cb335b9$var$EventHandler.off(window, $d0c6a6535cb335b9$var$EVENT_KEY$4);
        $d0c6a6535cb335b9$var$EventHandler.off(this._dialog, $d0c6a6535cb335b9$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $d0c6a6535cb335b9$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $d0c6a6535cb335b9$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $d0c6a6535cb335b9$var$reflow(this._element);
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $d0c6a6535cb335b9$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $d0c6a6535cb335b9$var$EventHandler.on(window, $d0c6a6535cb335b9$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $d0c6a6535cb335b9$var$EventHandler.one(this._element, $d0c6a6535cb335b9$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $d0c6a6535cb335b9$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $d0c6a6535cb335b9$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$2, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $d0c6a6535cb335b9$var$EventHandler.one(target, $d0c6a6535cb335b9$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $d0c6a6535cb335b9$var$EventHandler.one(target, $d0c6a6535cb335b9$var$EVENT_HIDDEN$4, ()=>{
            if ($d0c6a6535cb335b9$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $d0c6a6535cb335b9$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $d0c6a6535cb335b9$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$d0c6a6535cb335b9$var$enableDismissTrigger($d0c6a6535cb335b9$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$6 = 'offcanvas';
const $d0c6a6535cb335b9$var$DATA_KEY$3 = 'bs.offcanvas';
const $d0c6a6535cb335b9$var$EVENT_KEY$3 = `.${$d0c6a6535cb335b9$var$DATA_KEY$3}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY$1 = '.data-api';
const $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API$2 = `load${$d0c6a6535cb335b9$var$EVENT_KEY$3}${$d0c6a6535cb335b9$var$DATA_API_KEY$1}`;
const $d0c6a6535cb335b9$var$ESCAPE_KEY = 'Escape';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$3 = 'show';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOWING$1 = 'showing';
const $d0c6a6535cb335b9$var$CLASS_NAME_HIDING = 'hiding';
const $d0c6a6535cb335b9$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $d0c6a6535cb335b9$var$OPEN_SELECTOR = '.offcanvas.show';
const $d0c6a6535cb335b9$var$EVENT_SHOW$3 = `show${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_SHOWN$3 = `shown${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_HIDE$3 = `hide${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_HIDE_PREVENTED = `hidePrevented${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_HIDDEN$3 = `hidden${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_RESIZE = `resize${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$1 = `click${$d0c6a6535cb335b9$var$EVENT_KEY$3}${$d0c6a6535cb335b9$var$DATA_API_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$d0c6a6535cb335b9$var$EVENT_KEY$3}`;
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $d0c6a6535cb335b9$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $d0c6a6535cb335b9$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$591ca0244c9dfcd4 extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$5;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$5;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $d0c6a6535cb335b9$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOWING$1);
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$3, $d0c6a6535cb335b9$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $d0c6a6535cb335b9$var$ScrollBarHelper().reset();
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $d0c6a6535cb335b9$var$Backdrop({
            className: $d0c6a6535cb335b9$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $d0c6a6535cb335b9$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $d0c6a6535cb335b9$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API$1, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($d0c6a6535cb335b9$var$isDisabled(this)) return;
    $d0c6a6535cb335b9$var$EventHandler.one(target, $d0c6a6535cb335b9$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($d0c6a6535cb335b9$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $d0c6a6535cb335b9$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $d0c6a6535cb335b9$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$d0c6a6535cb335b9$var$EventHandler.on(window, $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$OPEN_SELECTOR))$d0c6a6535cb335b9$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$d0c6a6535cb335b9$var$EventHandler.on(window, $d0c6a6535cb335b9$var$EVENT_RESIZE, ()=>{
    for (const element of $d0c6a6535cb335b9$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $d0c6a6535cb335b9$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$d0c6a6535cb335b9$var$enableDismissTrigger($d0c6a6535cb335b9$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $d0c6a6535cb335b9$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $d0c6a6535cb335b9$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $d0c6a6535cb335b9$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $d0c6a6535cb335b9$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $d0c6a6535cb335b9$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $d0c6a6535cb335b9$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($d0c6a6535cb335b9$var$uriAttributes.has(attributeName)) return Boolean($d0c6a6535cb335b9$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $d0c6a6535cb335b9$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$d0c6a6535cb335b9$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$5 = 'TemplateFactory';
const $d0c6a6535cb335b9$var$Default$4 = {
    allowList: $d0c6a6535cb335b9$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $d0c6a6535cb335b9$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $d0c6a6535cb335b9$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$var$TemplateFactory extends $d0c6a6535cb335b9$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$4;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$4;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $d0c6a6535cb335b9$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $d0c6a6535cb335b9$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($d0c6a6535cb335b9$var$isElement(content)) {
            this._putElementInTemplate($d0c6a6535cb335b9$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $d0c6a6535cb335b9$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $d0c6a6535cb335b9$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$4 = 'tooltip';
const $d0c6a6535cb335b9$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $d0c6a6535cb335b9$var$CLASS_NAME_FADE$2 = 'fade';
const $d0c6a6535cb335b9$var$CLASS_NAME_MODAL = 'modal';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$2 = 'show';
const $d0c6a6535cb335b9$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $d0c6a6535cb335b9$var$SELECTOR_MODAL = `.${$d0c6a6535cb335b9$var$CLASS_NAME_MODAL}`;
const $d0c6a6535cb335b9$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $d0c6a6535cb335b9$var$TRIGGER_HOVER = 'hover';
const $d0c6a6535cb335b9$var$TRIGGER_FOCUS = 'focus';
const $d0c6a6535cb335b9$var$TRIGGER_CLICK = 'click';
const $d0c6a6535cb335b9$var$TRIGGER_MANUAL = 'manual';
const $d0c6a6535cb335b9$var$EVENT_HIDE$2 = 'hide';
const $d0c6a6535cb335b9$var$EVENT_HIDDEN$2 = 'hidden';
const $d0c6a6535cb335b9$var$EVENT_SHOW$2 = 'show';
const $d0c6a6535cb335b9$var$EVENT_SHOWN$2 = 'shown';
const $d0c6a6535cb335b9$var$EVENT_INSERTED = 'inserted';
const $d0c6a6535cb335b9$var$EVENT_CLICK$1 = 'click';
const $d0c6a6535cb335b9$var$EVENT_FOCUSIN$1 = 'focusin';
const $d0c6a6535cb335b9$var$EVENT_FOCUSOUT$1 = 'focusout';
const $d0c6a6535cb335b9$var$EVENT_MOUSEENTER = 'mouseenter';
const $d0c6a6535cb335b9$var$EVENT_MOUSELEAVE = 'mouseleave';
const $d0c6a6535cb335b9$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $d0c6a6535cb335b9$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $d0c6a6535cb335b9$var$isRTL() ? 'right' : 'left'
};
const $d0c6a6535cb335b9$var$Default$3 = {
    allowList: $d0c6a6535cb335b9$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $d0c6a6535cb335b9$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$28c660c63b792dea extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        if (typeof $1305c0a6451a6c72$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$3;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$3;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $d0c6a6535cb335b9$var$EventHandler.off(this._element.closest($d0c6a6535cb335b9$var$SELECTOR_MODAL), $d0c6a6535cb335b9$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_SHOW$2));
        const shadowRoot = $d0c6a6535cb335b9$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$d0c6a6535cb335b9$var$EventHandler.on(element, 'mouseover', $d0c6a6535cb335b9$var$noop);
        const complete = ()=>{
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$d0c6a6535cb335b9$var$EventHandler.off(element, 'mouseover', $d0c6a6535cb335b9$var$noop);
        this._activeTrigger[$d0c6a6535cb335b9$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$d0c6a6535cb335b9$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$d0c6a6535cb335b9$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_FADE$2, $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $d0c6a6535cb335b9$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $d0c6a6535cb335b9$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$d0c6a6535cb335b9$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $d0c6a6535cb335b9$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $d0c6a6535cb335b9$var$AttachmentMap[placement.toUpperCase()];
        return $1305c0a6451a6c72$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $d0c6a6535cb335b9$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$d0c6a6535cb335b9$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $d0c6a6535cb335b9$var$EventHandler.on(this._element, this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $d0c6a6535cb335b9$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $d0c6a6535cb335b9$var$TRIGGER_HOVER ? this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_MOUSEENTER) : this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $d0c6a6535cb335b9$var$TRIGGER_HOVER ? this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_MOUSELEAVE) : this.constructor.eventName($d0c6a6535cb335b9$var$EVENT_FOCUSOUT$1);
                $d0c6a6535cb335b9$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $d0c6a6535cb335b9$var$TRIGGER_FOCUS : $d0c6a6535cb335b9$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $d0c6a6535cb335b9$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $d0c6a6535cb335b9$var$TRIGGER_FOCUS : $d0c6a6535cb335b9$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $d0c6a6535cb335b9$var$EventHandler.on(this._element.closest($d0c6a6535cb335b9$var$SELECTOR_MODAL), $d0c6a6535cb335b9$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $d0c6a6535cb335b9$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($d0c6a6535cb335b9$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $d0c6a6535cb335b9$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$3 = 'popover';
const $d0c6a6535cb335b9$var$SELECTOR_TITLE = '.popover-header';
const $d0c6a6535cb335b9$var$SELECTOR_CONTENT = '.popover-body';
const $d0c6a6535cb335b9$var$Default$2 = {
    ...$d0c6a6535cb335b9$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $d0c6a6535cb335b9$var$DefaultType$2 = {
    ...$d0c6a6535cb335b9$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$5b6b19405a83ff9d extends $d0c6a6535cb335b9$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$2;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$2;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$d0c6a6535cb335b9$var$SELECTOR_TITLE]: this._getTitle(),
            [$d0c6a6535cb335b9$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$2 = 'scrollspy';
const $d0c6a6535cb335b9$var$DATA_KEY$2 = 'bs.scrollspy';
const $d0c6a6535cb335b9$var$EVENT_KEY$2 = `.${$d0c6a6535cb335b9$var$DATA_KEY$2}`;
const $d0c6a6535cb335b9$var$DATA_API_KEY = '.data-api';
const $d0c6a6535cb335b9$var$EVENT_ACTIVATE = `activate${$d0c6a6535cb335b9$var$EVENT_KEY$2}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK = `click${$d0c6a6535cb335b9$var$EVENT_KEY$2}`;
const $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API$1 = `load${$d0c6a6535cb335b9$var$EVENT_KEY$2}${$d0c6a6535cb335b9$var$DATA_API_KEY}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1 = 'active';
const $d0c6a6535cb335b9$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $d0c6a6535cb335b9$var$SELECTOR_TARGET_LINKS = '[href]';
const $d0c6a6535cb335b9$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $d0c6a6535cb335b9$var$SELECTOR_NAV_LINKS = '.nav-link';
const $d0c6a6535cb335b9$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $d0c6a6535cb335b9$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $d0c6a6535cb335b9$var$SELECTOR_LINK_ITEMS = `${$d0c6a6535cb335b9$var$SELECTOR_NAV_LINKS}, ${$d0c6a6535cb335b9$var$SELECTOR_NAV_ITEMS} > ${$d0c6a6535cb335b9$var$SELECTOR_NAV_LINKS}, ${$d0c6a6535cb335b9$var$SELECTOR_LIST_ITEMS}`;
const $d0c6a6535cb335b9$var$SELECTOR_DROPDOWN = '.dropdown';
const $d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $d0c6a6535cb335b9$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $d0c6a6535cb335b9$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$a6472a5298a374be extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default$1;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType$1;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $d0c6a6535cb335b9$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $d0c6a6535cb335b9$var$EventHandler.off(this._config.target, $d0c6a6535cb335b9$var$EVENT_CLICK);
        $d0c6a6535cb335b9$var$EventHandler.on(this._config.target, $d0c6a6535cb335b9$var$EVENT_CLICK, $d0c6a6535cb335b9$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $d0c6a6535cb335b9$var$isDisabled(anchor)) continue;
            const observableSection = $d0c6a6535cb335b9$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($d0c6a6535cb335b9$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($d0c6a6535cb335b9$var$SELECTOR_DROPDOWN)).classList.add($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $d0c6a6535cb335b9$var$SelectorEngine.parents(target, $d0c6a6535cb335b9$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $d0c6a6535cb335b9$var$SelectorEngine.prev(listGroup, $d0c6a6535cb335b9$var$SELECTOR_LINK_ITEMS))item.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $d0c6a6535cb335b9$var$SelectorEngine.find(`${$d0c6a6535cb335b9$var$SELECTOR_TARGET_LINKS}.${$d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(window, $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_DATA_SPY))$d0c6a6535cb335b9$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME$1 = 'tab';
const $d0c6a6535cb335b9$var$DATA_KEY$1 = 'bs.tab';
const $d0c6a6535cb335b9$var$EVENT_KEY$1 = `.${$d0c6a6535cb335b9$var$DATA_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_HIDE$1 = `hide${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_HIDDEN$1 = `hidden${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_SHOW$1 = `show${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_SHOWN$1 = `shown${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API = `click${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_KEYDOWN = `keydown${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API = `load${$d0c6a6535cb335b9$var$EVENT_KEY$1}`;
const $d0c6a6535cb335b9$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $d0c6a6535cb335b9$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $d0c6a6535cb335b9$var$ARROW_UP_KEY = 'ArrowUp';
const $d0c6a6535cb335b9$var$ARROW_DOWN_KEY = 'ArrowDown';
const $d0c6a6535cb335b9$var$HOME_KEY = 'Home';
const $d0c6a6535cb335b9$var$END_KEY = 'End';
const $d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE = 'active';
const $d0c6a6535cb335b9$var$CLASS_NAME_FADE$1 = 'fade';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$1 = 'show';
const $d0c6a6535cb335b9$var$CLASS_DROPDOWN = 'dropdown';
const $d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $d0c6a6535cb335b9$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $d0c6a6535cb335b9$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $d0c6a6535cb335b9$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $d0c6a6535cb335b9$var$SELECTOR_INNER = `.nav-link${$d0c6a6535cb335b9$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$d0c6a6535cb335b9$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$d0c6a6535cb335b9$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $d0c6a6535cb335b9$var$SELECTOR_INNER_ELEM = `${$d0c6a6535cb335b9$var$SELECTOR_INNER}, ${$d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE}`;
const $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$3e41faf802a29e71 extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($d0c6a6535cb335b9$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $d0c6a6535cb335b9$var$EventHandler.trigger(active, $d0c6a6535cb335b9$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(innerElem, $d0c6a6535cb335b9$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE);
        this._activate($d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $d0c6a6535cb335b9$var$EventHandler.trigger(element, $d0c6a6535cb335b9$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $d0c6a6535cb335b9$var$EventHandler.trigger(element, $d0c6a6535cb335b9$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $d0c6a6535cb335b9$var$ARROW_LEFT_KEY,
            $d0c6a6535cb335b9$var$ARROW_RIGHT_KEY,
            $d0c6a6535cb335b9$var$ARROW_UP_KEY,
            $d0c6a6535cb335b9$var$ARROW_DOWN_KEY,
            $d0c6a6535cb335b9$var$HOME_KEY,
            $d0c6a6535cb335b9$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$d0c6a6535cb335b9$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $d0c6a6535cb335b9$var$HOME_KEY,
            $d0c6a6535cb335b9$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $d0c6a6535cb335b9$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $d0c6a6535cb335b9$var$ARROW_RIGHT_KEY,
                $d0c6a6535cb335b9$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $d0c6a6535cb335b9$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $d0c6a6535cb335b9$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $d0c6a6535cb335b9$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($d0c6a6535cb335b9$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $d0c6a6535cb335b9$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_TOGGLE, $d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE);
        toggle($d0c6a6535cb335b9$var$SELECTOR_DROPDOWN_MENU, $d0c6a6535cb335b9$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($d0c6a6535cb335b9$var$SELECTOR_INNER_ELEM) ? elem : $d0c6a6535cb335b9$var$SelectorEngine.findOne($d0c6a6535cb335b9$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($d0c6a6535cb335b9$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$EventHandler.on(document, $d0c6a6535cb335b9$var$EVENT_CLICK_DATA_API, $d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($d0c6a6535cb335b9$var$isDisabled(this)) return;
    $d0c6a6535cb335b9$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $d0c6a6535cb335b9$var$EventHandler.on(window, $d0c6a6535cb335b9$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $d0c6a6535cb335b9$var$SelectorEngine.find($d0c6a6535cb335b9$var$SELECTOR_DATA_TOGGLE_ACTIVE))$d0c6a6535cb335b9$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $d0c6a6535cb335b9$var$NAME = 'toast';
const $d0c6a6535cb335b9$var$DATA_KEY = 'bs.toast';
const $d0c6a6535cb335b9$var$EVENT_KEY = `.${$d0c6a6535cb335b9$var$DATA_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_MOUSEOVER = `mouseover${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_MOUSEOUT = `mouseout${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_FOCUSIN = `focusin${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_FOCUSOUT = `focusout${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_HIDE = `hide${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_HIDDEN = `hidden${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_SHOW = `show${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$EVENT_SHOWN = `shown${$d0c6a6535cb335b9$var$EVENT_KEY}`;
const $d0c6a6535cb335b9$var$CLASS_NAME_FADE = 'fade';
const $d0c6a6535cb335b9$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOW = 'show';
const $d0c6a6535cb335b9$var$CLASS_NAME_SHOWING = 'showing';
const $d0c6a6535cb335b9$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $d0c6a6535cb335b9$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $d0c6a6535cb335b9$export$8d8dc7d5f743331b extends $d0c6a6535cb335b9$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $d0c6a6535cb335b9$var$Default;
    }
    static get DefaultType() {
        return $d0c6a6535cb335b9$var$DefaultType;
    }
    static get NAME() {
        return $d0c6a6535cb335b9$var$NAME;
    }
    // Public
    show() {
        const showEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOWING);
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_HIDE); // @deprecated
        $d0c6a6535cb335b9$var$reflow(this._element);
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOW, $d0c6a6535cb335b9$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOWING, $d0c6a6535cb335b9$var$CLASS_NAME_SHOW);
            $d0c6a6535cb335b9$var$EventHandler.trigger(this._element, $d0c6a6535cb335b9$var$EVENT_HIDDEN);
        };
        this._element.classList.add($d0c6a6535cb335b9$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($d0c6a6535cb335b9$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($d0c6a6535cb335b9$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $d0c6a6535cb335b9$var$EventHandler.on(this._element, $d0c6a6535cb335b9$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $d0c6a6535cb335b9$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $d0c6a6535cb335b9$var$enableDismissTrigger($d0c6a6535cb335b9$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $d0c6a6535cb335b9$var$defineJQueryPlugin($d0c6a6535cb335b9$export$8d8dc7d5f743331b);


const $2f1de8e3c2b4c993$var$modal = new (0, $d0c6a6535cb335b9$export$2b77a92f1a5ad772)('#fullscreen-menu-modal', {});
(0, (/*@__PURE__*/$parcel$interopDefault($bWXzv)))('.js-hamburger').on('click', function() {
    $2f1de8e3c2b4c993$var$modal.show();
});
(0, (/*@__PURE__*/$parcel$interopDefault($bWXzv)))('#fullscreen-menu-modal').on('click', '.js-fullscreen-menu li a', function() {
    $2f1de8e3c2b4c993$var$modal.hide();
}); // $('.js-hamburger').on('click', function () {
 //   /**
 //    * Remove focus before opening the modal.
 //    * 
 //    * Bootstrap modal returns focus to the element that was focused when the modal was opened,
 //    * disable this because we have scroll to links in the modal, we want to scroll
 //    * to them but return of focus scrolls back to the hamburger.
 //    */
 //   // $(':focus').trigger('blur'); // doesn't work
 //   /**
 //    * This method doesn't return focus to the triggering element
 //    */
 //   modal.show();
 // });
 // $('.js-fullscreen-menu-modal').on('click', '.js-fullscreen-menu li a', function () {
 //   const $link = $(this);
 //   console.log('123');
 //   $(this).css('background-color', 'red');
 //   const modal = Modal.getInstance($link.closest('.js-fullscreen-menu-modal').get(0));
 //   if (modal) {
 //     modal.hide();
 //   }
 // });



var $bWXzv = parcelRequire("bWXzv");

(0, (/*@__PURE__*/$parcel$interopDefault($bWXzv)))(".js-image-slider").each(function() {
    const $block = (0, (/*@__PURE__*/$parcel$interopDefault($bWXzv)))(this);
    const $track = $block.find(".js-image-slider__track");
    //   const $prev = $block.find(".js-slider-arrow-prev");
    //   const $next = $block.find(".js-slider-arrow-next");
    const $dots = $block.find(".js-image-slider__dots");
    $track.slick({
        infinite: true,
        centerMode: true,
        autoplay: false,
        // slidesToShow: 3,
        // slidesToScroll: 1,
        variableWidth: true,
        dots: true,
        dotsClass: "",
        appendDots: $dots,
        draggable: true,
        adaptiveHeight: true,
        arrows: false,
        // nextArrow: $next,
        // prevArrow: $prev,
        fade: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true
                }
            }
        ]
    });
});


(0, (/*@__PURE__*/$parcel$interopDefault($a8deec0f19dfb2f6$exports))).init();
 // console.log( add( 1, 2 ) );
 // console.log( selectSomething() );


//# sourceMappingURL=index.daf16a03.js.map
